var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M705.3 514.2L1146.5 0.900024H1045.6L660.3 448.8L351.9 0.900024H2.10001L466 674.9L0.700012 1216.4H101.6L511 740.2L838.8 1216.4H1188.7L705.3 514.2ZM880.3 1137.3L152.6 80H310.3L1038 1137.3H880.3Z","fill":"currentColor"}));
}

X.defaultProps = {"width":"1189","height":"1217","viewBox":"0 0 1189 1217"};

module.exports = X;

X.default = X;
